<template>
    <div
        class="c-shipping-info js-tippy-remote h-cursor-help"
        :data-remote-url="tooltipUrl"
        v-html="shippingText"
    ></div>
</template>

<script>
import { initTippy } from "Functions/tippy";
import client from "FrontendJsAssets/common/client";
import { formatPrice } from "FrontendJsAssets/common/format";

export default {
    props: {
        initialData: {
            type: Object,
            required: true,
        },
    },
    data: () => ({
        freeLimit: null,
        freeAmount: null,
        productPrice: null,
        hasProductFreeShipping: null,
        isEmptyCart: false,
        texts: [],
        tooltipUrl: null,
    }),
    created() {
        this.cheapestShipping = this.initialData.cheapestShipping;
        this.freeLimit = this.initialData.freeLimit;
        this.freeAmount = this.initialData.freeAmount;
        this.productPrice = this.initialData.productPrice;
        this.hasProductFreeShipping = this.initialData.hasProductFreeShipping;
        this.isEmptyCart = this.initialData.isEmptyCart;
        this.texts = this.initialData.texts;
        this.tooltipUrl = this.initialData.tooltipUrl;

        window.rEvent.on("Custom.Cart.addedItem", (data) => {
            this.updateData(data.response);
        });
        window.rEvent.on("Custom.Cart.updatedItem", (data) => {
            this.updateData(data.response);
        });
        window.rEvent.on("Custom.Cart.removedItem", (data) => {
            this.updateData(data.response);
        });
        window.rEvent.on("Cart.product.removed", (data) => {
            this.updateData(data);
        });
    },
    mounted() {
        this.$nextTick(() => {
            initTippy(".js-tippy-remote", {
                onShow(instance) {
                    instance.setContent('<div class="c-shipping-prices-tooltip is-loading"></div>');

                    if (!instance.reference.dataset.remoteUrl) return;

                    client
                        .get(instance.reference.dataset.remoteUrl)
                        .then((response) => {
                            instance.setContent(response.data);
                        })
                        .catch((error) => {
                            console.log(error);
                            instance.setContent(
                                `<div class="c-shipping-prices-tooltip"><div class="h-is-red">${error?.response?.data?.message}</div></div>`
                            );
                        });
                },
            });
        });
    },
    methods: {
        updateData(response) {
            if (!response.free_shipping) {
                return;
            }

            this.cheapestShipping = response.free_shipping.cheapest_shipping;
            this.freeAmount = response.free_shipping.price;
            this.isEmptyCart = response.totals.quantity <= 0;
        },
    },
    computed: {
        hasFreeShipping() {
            return this.hasProductFreeShipping || this.productPrice >= this.freeLimit;
        },
        shippingText() {
            let textKey = "";

            if (this.hasFreeShipping) {
                textKey = this.freeAmount > 0 ? "textProductFree" : "textFree";
            } else if (this.isEmptyCart) {
                textKey = this.hasFreeShipping ? "textProductFree" : "textEmpty";
            } else {
                textKey = this.freeAmount > 0 ? "text" : "textFree";
            }

            return this.texts[textKey]
                .replace(":shippingMinPrice", formatPrice(this.cheapestShipping))
                .replace(":freeAmount", formatPrice(this.freeAmount))
                .replace(":freeLimit", formatPrice(this.freeLimit));
        },
    },
};
</script>
